import '../style/azmoon-list/AL_SearchTag.css';
import { AiOutlineRise } from "react-icons/ai";


let data_list = [
  {
    id:1,
    name:"محبوب‌ترین‌ها",
    isAtive:true
  },
  {
    id:2,
    name:"پرفروش‌ترین‌ها",
    isAtive:false
  },
  {
    id:3,
    name:"پربازدیدترین‌ها",
    isAtive:false
  },
  {
    id:4,
    name:"جدیدترین‌ها",
    isAtive:false
  },
] 

const AL_SearchTag=()=>{
  return(
    <div className="al-search-tag">
      <AiOutlineRise className="al-search-tag-icon"/>
      <div className="al-search-tag-items">
        {data_list.map(item=>(
          <div style={item.isAtive ? {color:"#2E81E8",fontWeight:"bold"}: null} key={item.id} className="al-s-i_item">
            {item.name}
          </div>
        ))}
      </div>
    </div>
  )
}

export default AL_SearchTag;